import type * as React from 'react';
import { get } from '@Domain/Api';
import templateAssignmentScopePath from '@Application/Documents/TemplateAssignments/templateAssignmentScopePath';
import templateAssignmentsFetched, {
	type TemplateAssignmentsFetchedAction,
	type TemplateAssignmentsFetchedPayload,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentsFetched';
import templateAssignmentsFetchFailed, {
	type TemplateAssignmentsFetchFailedAction,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentsFetchFailed';
import type FetchTemplateAssignments from '@Application/Documents/TemplateAssignments/Queries/FetchTemplateAssignments';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = TemplateAssignmentsFetchedAction | TemplateAssignmentsFetchFailedAction;

export default (query: FetchTemplateAssignments) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<TemplateAssignmentsFetchedPayload>(
				`${parameters.api.host}/api/${templateAssignmentScopePath(query.scope)}`,
			);

			const action = templateAssignmentsFetched(payload, query.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = templateAssignmentsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
